import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=3226b4bc&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"
import style0 from "./Credit.vue?vue&type=style&index=0&id=3226b4bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226b4bc",
  null
  
)

export default component.exports